const LRType = {
  PREVIOUS_LR_SERIES: -1,
  CURRENT_LR_SERIES: 0,
  NEXT_LR_SERIES: 1,
};
module.exports = { LRType };
